module.exports = __webpack_public_path__ + "img/guante-5.6e7f1d19.jpg";